import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { GetParams, GetResponse, PostResponse, State } from '@app/shared';
import { Observable, tap } from 'rxjs';
import { convertGetParamsToHttpParams } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  /** URLs principales relacionadas con Locations y Transports **/
  stateUrl = environment.coreApiBaseUrl + '/api/State';

  constructor(private http: HttpClient) {}

  /** Metodos de obtener/crear/actualizar/eliminar State **/
  getState(getParams: GetParams): Observable<GetResponse> {
    return this.http
      .get<GetResponse>(this.stateUrl, {
        params: convertGetParamsToHttpParams(getParams),
      })
  }

  createState(newState: {
    name: string;
    isActive: boolean;
  }): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.stateUrl, newState)
  }

  updateState(state: State): Observable<any> {
    return this.http.put<PostResponse>(this.stateUrl, state)
  }

  deleteState(ids: number[]): Observable<any> {
    return this.http
      .delete<PostResponse>(this.stateUrl, { body: { ids } })
  }
}
